export default __webpack_public_path__ + "media/src/usersite/images/header/sns_banners/pc_sns_tab-f547f8b4d65183ffac20dd69b86af312.png";